import MovimientoFormCompra from './MovimientoFormCompra'
export { MovimientoFormCompra }
export default MovimientoFormCompra
